export enum TimeInMs {
  second = 1000,
  minute = 60 * TimeInMs.second,
  hour = 60 * TimeInMs.minute,
  day = 24 * TimeInMs.hour,
  week = 7 * TimeInMs.day,
  month = 30 * TimeInMs.day,
  year = 365 * TimeInMs.day
}
